import React from 'react';
import { Wrap, EasyActions, EasyWin, Loader } from '../../components/index';
import * as _ from 'lodash';
import { useResponsivity } from '../../helpers/helpers';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';
interface SingleToiletProps {
  challenges: any;
  listLocation: any;
  getChallengeCategory: Function;
  completeTask: any;
  completeChallenge: Function;
  generalData: Function;
  getOffers: Function;
}

const SingleToilet: React.FC<SingleToiletProps> = (props) => {
  const {
    challenges,
    getChallengeCategory,
    completeTask,
    completeChallenge,
    generalData,
    getOffers,
  } = props;
  const getRoomId = store('property');

  const loadingChallenges = _.get(challenges, 'status.loading');
  const data = _.get(challenges, 'data.challenges');
  const offers = _.get(challenges, 'offers.data.challenges');

  const isMobile = useResponsivity();
  const plumberVisit = _.find(offers, function (o) {
    return o.tag.includes('PLUMBER_VISIT');
  });
  const [t] = useTranslation('common');
  const { error, loading, done } = _.get(completeTask, 'status');
  React.useEffect(() => {
    getChallengeCategory(getRoomId, 'toilets');
    getOffers(getRoomId);
  }, [getRoomId]);
  const pageArray = [
    {
      title: 'Single flush toilet',
      icon: 'shower',
      description:
        'Single flush toilets are big users of water since they use the same volume of water to flush each time.',
      easyWins: [
        {
          title: 'Engage staff',
          size: 'half',
          hasLogo: false,
          description: [
            'Encourage staff to report if they spot a leaking toilet. Toilets with an evidently constant flow of water into the pan could be wasting as much as 400 litres every day, even at weekends when staff are at home – which will have a huge impact on your water bill.',
          ],
        },
        {
          title: 'Tell us your achievements',
          description: [
            'Confirm which actions you’ve completed to see how much water and money we think you’ll save.',
          ],
          theme: 'blue',
          size: 'half',
          hasLogo: false,
          isEasyAction: true,
        },
        {
          title: 'Plumber Tips',
          size: 'half',
          icon: 'toilet',
          hasLogo: false,
          description: [
            'The simplest way to save water with single flush toilets is to convert to a dual flush. It’s not as hard as it sounds, takes around 20 minutes without needing to change the flushing mechanism or the flushing lever. This allows the operator to hold down the lever for a big flush and let go for a small flush.',
            'Whichever way the single lever toilet is converted, each staff member can reduce their water use by as much as 15.5 litres every day.',
          ],
        },
        {
          title: 'Fix a leak',
          size: 'half',
          hasLogo: false,
          icon: 'fixLeak',
          buttonText:
            plumberVisit !== undefined
              ? 'Book a Free plumber visit'
              : 'Find a plumber',
          linkType:
            plumberVisit !== undefined ? 'internalLink' : 'externalLink',
          buttonPath:
            plumberVisit !== undefined
              ? '/actions'
              : 'https://www.watersafe.org.uk',
          buttonIcon: null,

          description: [
            'Even small leaks waste a surprising amount of water so do check toilets regularly. To look for minor leaks, place a sheet of toilet paper at the back of the pan. Any water leaking from the cistern will make the tissue wet.',
            'Once a toilet begins to leak, it’s important to get it fixed. A small dribble is likely to turn into a constant flow of water, which if left unchecked, could add significantly to the running costs of your business.',
          ],
        },

        {
          title: 'Smart products',
          theme: 'green',
          size: 'full',
          hasLogo: true,
          icon: null,
          linkType: 'externalLink',
          buttonText: 'Find water efficient toilets',
          buttonPath:
            'https://uk.getwatersmart.com/products?category=BathroomToilets',
          description: [
            'The simplest way to save water is to replace single flush toilets with a dual flush. Depending on the type of toilet, you may only need to replace the internal flushing mechanism. It’s not as hard as it sounds, taking no more than 20 minutes without needing to remove either the cistern or the pan.',
            'Whichever way the single lever toilet is converted, each staff member can reduce their water use by as much as 15.5 litres every day.',
          ],
        },
      ],
    },
  ];

  const getChallenges = () => {
    return _.map(data, (el, index) => {
      const title = _.get(el, 'title');
      const description = _.get(el, 'description');
      const buttonText = _.get(el, 'buttonText');
      const type = _.get(el, 'internalType');
      const buttonPath = _.get(el, 'buttonPath');
      const energySaving = _.get(el, 'energy_saving');
      const carbonSaving = _.get(el, 'carbon_saving');
      const waterSaving = _.get(el, 'water_saving');
      const exType = _.get(el, 'type');
      return (
        <Col xs={12} sm={12} md={12} key={index}>
          <EasyActions
            isDesktop={!isMobile}
            icon={_.get(el, 'icon')}
            id={_.get(el, 'id')}
            title={`${t(title)}`}
            description={`${t(description)}`}
            buttonText={`${t(buttonText)}`}
            buttonPath={buttonPath}
            popup={type === 'direct-redirect' ? false : true}
            renderComplete={() => {
              completeChallenge(getRoomId, _.get(el, 'id'));
              setTimeout(() => {
                getChallengeCategory(getRoomId, 'toilets');
                generalData();
              }, 1000);
            }}
            isLoading={loading}
            completed={done}
            energySaving={energySaving}
            carbonSaving={carbonSaving}
            waterSaving={waterSaving}
            type={exType}
          />
        </Col>
      );
    });
  };
  if (loadingChallenges) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  return (
    <Wrap>
      <EasyWin data={pageArray}>
        <Row style={{ marginTop: '16px' }}>{getChallenges()}</Row>
      </EasyWin>
    </Wrap>
  );
};

export default SingleToilet;
